import React from "react";
import MainLayout from "../../../components/Layouts";
import SettlementDetails from "../../../components/settlement/settledMentOrderDetails";

const settlementOrderDetails = () => {
  return (
    <MainLayout>
      <SettlementDetails />
    </MainLayout>
  );
};

export default settlementOrderDetails;
